import { API } from "@project/common"

interface IStaffAttendanceMonthlyScheduleWorkStyle {
  facility: string | number
  year: string | number
  month: string | number
  load_excel_data?: string | number
}

const BASE_ATTENDANCE_SCHEDULE_URL = "/staff-schedules"

export const getStaffAttendanceMonthlyScheduleWorkStyle = ({
  facility,
  year,
  month,
  load_excel_data = "",
}: IStaffAttendanceMonthlyScheduleWorkStyle) => {
  return API.get(
    `${BASE_ATTENDANCE_SCHEDULE_URL}/work-style?facility=${facility}&year=${year}&month=${month}&load_excel_data=${load_excel_data}`,
  )
}

export const quickUpdateStaffAttendanceSchedule = (payload) =>
  API.post(BASE_ATTENDANCE_SCHEDULE_URL, payload)

export const getStaffAttendanceScheduleAlerts = ({ facility, year, month }) =>
  API.get(
    `${BASE_ATTENDANCE_SCHEDULE_URL}/alerts?facility=${facility}&year=${year}&month=${month}`,
  )
